import { render } from "./AboutView.vue?vue&type=template&id=542e5ae4&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=542e5ae4&scoped=true&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542e5ae4"]])

export default __exports__